import { useSingleMinigrid } from "../../../hook";
import LocationMapView from "./LocationMapView/LocationMapView";

export default function LocationMapPresenter() {
  const {
    singleMinigridQuery: { data },
  } = useSingleMinigrid();

  return (
    <LocationMapView
      lng={data?.minigrid_location_lng}
      lat={data?.minigrid_location_lat}
      namePin={
        data?.minigrid_name +
        ` (${data?.minigrid_location_lat} ${data?.minigrid_location_lng})`
      }
    />
  );
}
